import Vue from 'vue';

module.exports = Vue.component('user-profile', {
    props: ['user'],
    template: '#user-profile',
    methods: {
    	
    }
});


//////////////